module.exports = __webpack_public_path__ + "static/images/msg-score-enter.7b45d21.png";